/*
 * Copyright (C) 2022 Worldline
 * All Rights Reserved
 * This product is protected by copyright. Any copying or distribution
 * is forbidden without the agreement of Worldline.
 */
import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDrawerContent, MatSidenavContent } from "@angular/material/sidenav";
import { NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NotifMessageService } from "app/core/services/notifmessage.service";
import { NGXLogger } from "ngx-logger";
import { Subscription } from "rxjs";
import { KeycloakService } from "security/keycloak.service";
import { ConfigurationService } from "./core/services/configuration.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild(MatSidenavContent) matSidenavContent: MatSidenavContent;
  title = "Pay & Drive BO";
 
  navItems: any[];
  mobileQuery: MediaQueryList;

  // save the subscription to unsubscribe at the end of the application ...
  private securityEvents: Subscription = null;
  sub: Subscription;

  private _mobileQueryListener: () => void;

  constructor(
    private log: NGXLogger,
    private translateService: TranslateService,
    private securityService: KeycloakService,
    private notifService: NotifMessageService,
    private configService: ConfigurationService,
    private router : Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 800px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener("change", this._mobileQueryListener);
  }

  ngOnInit(): void {

    let languageKeys = this.configService.config.languages.map((language) => {
      return language.key;
    });

    this.translateService.addLangs(languageKeys);
    this.translateService.setDefaultLang(
      this.configService.config.defaultLanguage
    );
    this.translateService.use(this.configService.config.defaultLanguage);

    this.securityEvents = this.securityService
      .retrieveEventStream()
      .subscribe((event) => {
        if (
          this.configService.config.security.notification.error_events &&
          this.configService.config.security.notification.error_events.includes(
            event
          )
        ) {
          this.notifService.notifyErrorWithoutDetail("SECURITY_MSG_" + event);
        } else if (
          this.configService.config.security.notification.info_events &&
          this.configService.config.security.notification.info_events.includes(
            event
          )
        ) {
          this.notifService.notifyInfo("SECURITY_MSG_" + event);
        } else if (
          this.configService.config.security.notification.warn_events &&
          this.configService.config.security.notification.warn_events.includes(
            event
          )
        ) {
          this.notifService.notifyWarn("SECURITY_MSG_" + event);
        }
      });

      this.router.events.forEach((event) => {
        if(event instanceof NavigationEnd) {
          this.matSidenavContent.scrollTo({top: 0});
        }
      });
  }

  ngOnDestroy(): void {
    if (this.securityEvents) {
      this.securityEvents.unsubscribe();
    }
    this.mobileQuery.removeEventListener("change", this._mobileQueryListener);
  }
}
